module.exports = __webpack_public_path__ + "static/media/9_3.2110c318.png";